import { useMessage } from '@core/context/messageContext';
import { useTranslation } from 'react-i18next';

import checkImg from '@assets/images/check-light.png';
import errorImg from '@assets/images/error.png';
import { APImage } from '@components/atoms/APImage';
import { Typography } from '@components/atoms/Typography';

import { getMessageFromInternalTerm } from './utils';

export const PaymentStatusPage = () => {
  const { message } = useMessage();
  const { t } = useTranslation();

  const { status, title, description } = getMessageFromInternalTerm(message, t);

  return (
    <div className="flex-1 w-full justify-center items-center flex flex-col bg-[#F3F6F6] p-8">
      <div className="flex flex-col w-full h-full max-w-sm text-center justify-center items-center">
        {status && (
          <APImage
            img={status === 'success' || status === 'warning' ? checkImg : errorImg}
            width={150}
            height={150}
            loadingStrategy="eager"
          />
        )}

        {title && <Typography variant="h1" weight={500} text={title} className="text-[20px]" />}

        <Typography text={description} className="text-sm text-gray-500 m-2" variant="span" />
      </div>
    </div>
  );
};
